import * as React from 'react';

export function ParticipationLimits({tournament}: any) {
  const limits = [
    {label: 'Team members', value: tournament.maxPlayersPerTeam},
    {label: 'Individual events / student', value: tournament.maxIndividualEventsPerStudent},
    {label: 'Relay/team events / student', value: tournament.maxRelayEventsPerStudent}
  ];
  const sportLimitsEnforced = tournament.isEventParticipantLimitEnforced !== false;
  return <aside className="tpParticipationLimits" aria-label="Tournament entry limits">
    {limits.map(({label, value}) => <span className="tpParticipationLimits__chip" key={label}>
      {label}<strong>{Number(value) > 0 ? Number(value) : 'No limit'}</strong>
    </span>)}
    <span className="tpParticipationLimits__chip tpParticipationLimits__sport" title={sportLimitsEnforced
      ? 'Sport limits also apply per event. Available places are shown with each event.'
      : 'Sport participant limits are not enforced for this tournament.'}>
      Sport limits <strong>{sportLimitsEnforced ? 'Apply per event' : 'Not enforced'}</strong>
    </span>
  </aside>;
}
